import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getCountries, getLanguages, getCountryDomainAndSubDomain, openCountryDetail } from "../../actions/CountryActions";

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";

class Country extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country: 0,
            languages: [],
            isValid: false,
            errorMessage: ''
        };

        this.isValid = this.isValid.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onMultiSelectChange = this.onMultiSelectChange.bind(this);
    }

    componentWillMount() {
        this.getCountries();
        this.getLanguages();
        this.getCountryDomainAndSubDomain();
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onMultiSelectChange(e) {
        let languages = Array.prototype.slice.call(e.target.selectedOptions).map(o => o.value);

        this.setState({
            languages: languages
        })
    }

    isValid() {
        if (this.state.country === 0) {
            this.setState({
                isValid: false,
                errorMessage: "Please select a country."
            });
            return false;
        }
        if (this.state.languages.length <= 0) {
            this.setState({
                isValid: false,
                errorMessage: "Please select a language."
            });
            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        if(this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addCountryLanguage({
                countryId: this.state.country,
                languageIds: this.state.languages
            });
        }
    }

    getCountries() {
        axios.get(vars.BASE_URL+'/getCountries')
            .then((response) => {
                if (response.data.success) {
                    this.props.getCountries(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
            })
    }

    getLanguages() {
        axios.get(vars.BASE_URL+'/getLanguages')
            .then((response) => {
                if (response.data.success) {
                    this.props.getLanguages(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
            })
    }

    addCountryLanguage(data) {
        this.props.show();
        axios.post(vars.BASE_URL+'/addCountryLanguage', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getCountryDomainAndSubDomain();
                    this.setState({
                        country: 0,
                        isValid: false,
                        errorMessage: ''
                    })
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to post data.'});
            })
    }

    getCountryDomainAndSubDomain() {
        this.props.show();
        axios.get(vars.BASE_URL+'/getCountryDomainAndSubDomain')
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.props.getCountryDomainAndSubDomain(response.data);
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
            })
    }

    countryDetails(data) {
        this.props.openCountryDetail(data);
        this.props.history.push('/manage-country');
    }

    countryDelete(data) {
        this.props.show();
        axios.delete(vars.BASE_URL+'/deleteCountryLanguage', { data: {
            countryId: data.countryId
        }})
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getCountryDomainAndSubDomain();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot delete country right now, please try again later.'});
            });
    }

    render() {
        return (
            <div className="country animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Country</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="country">Country Name</Label>
                                        </Col>
                                        <Col xs="12" md="9" size="lg">
                                            <Input type="select" name="country" id="country" value={this.state.country} onChange={this.onChange}>
                                                <option key={0} value={0}>Country Name</option>
                                                {(this.props.country.countries.length > 0)?
                                                    this.props.country.countries.map((country, k) => {
                                                        return <option key={country.countryId} value={country.countryId}>{country.name}</option>
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="languages">Multiple select</Label>
                                        </Col>
                                        <Col md="9">
                                            <Input type="select" name="languages" id="languages" defaultValue={[]} onChange={this.onMultiSelectChange} multiple>
                                                {(this.props.country.languages.length > 0)?
                                                    this.props.country.languages.map((language, k) => {
                                                        return <option key={language.languageId} value={language.languageId}>{language.englishName}</option>
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.onSubmit}><i className="fa fa-check"></i> Add</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="country-custom-table">
                                    <thead>
                                        <tr>
                                            {/*<th>*/}
                                                {/*<input type="checkbox" size="lg" id="select-all" name="select-all" value="select-all" className="form-control-lg"/>*/}
                                            {/*</th>*/}
                                            <th>Country</th>
                                            <th>Language</th>
                                            <th>Domain</th>
                                            <th>Sub-Domain</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.country.countryDomain.length > 0) ?
                                            this.props.country.countryDomain.map((v, k) => {
                                                return (
                                                    <tr key={k}>
                                                        <td><strong>{v.country}</strong></td>
                                                        <td>
                                                            {v.language.map(l => {
                                                                return (
                                                                    <span key={l.languageId} className="gray-highlight">{l.languageCode}</span>
                                                                )
                                                            })}
                                                        </td>
                                                        <td>
                                                            {v.domain.map(d => {
                                                                return (
                                                                    <span key={d.domainId} className="mr-2">{d.domainUrl}</span>
                                                                )
                                                            })}
                                                        </td>
                                                        <td>
                                                            {v.subDomain.map(s => {
                                                                return (
                                                                    <span key={s.subDomainId} className="green-highlight">{s.subDomainName}</span>
                                                                )
                                                            })}
                                                        </td>
                                                        <td>
                                                            <Button size="sm" color="success" onClick={this.countryDetails.bind(this, v)}>
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                            <Button size="sm"  color="danger" onClick={this.countryDelete.bind(this, v)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            : <tr>
                                                <td>
                                                    No Countries added yet.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </Table>
                            </CardBody>
                            {/*<CardFooter className="card-footer-align-right">*/}
                                {/*<Button color="danger">*/}
                                    {/*<i className="fa fa-trash"></i> Delete All*/}
                                {/*</Button>*/}
                            {/*</CardFooter>*/}
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getCountries,
        getLanguages,
        getCountryDomainAndSubDomain,
        openCountryDetail
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Country);


// WEBPACK FOOTER //
// ./src/components/Country/Country.js